const SCREENSHOT_BASE_PATH = '/screenshots/';

const encodePath = (path: string) => (
  path
    .split('/')
    .map(segment => encodeURIComponent(segment))
    .join('/')
);

export const getScreenshotSrc = (screenshot: string) => {
  const value = screenshot.trim();

  if (
    value.startsWith('data:') ||
    value.startsWith('blob:') ||
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('/')
  ) {
    return value;
  }

  return `${SCREENSHOT_BASE_PATH}${encodePath(value)}`;
};
